import * as angular from "angular";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { Appointment } from "../../models/appointment.model";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Effort } from "../../models/effort.model";

let CanvassItemComponent = {
    selector: "vcCanvassItem",
    templateUrl: "/angular/components/activity/canvass-item.component.html",
    bindings: {
        activity: "=?",
        personLink: "=?",
        allowCanvass: "=?",
        deleteCanvass: "&",
        openCanvassDialog: "&",
        openViewHouseOccupantDialog: "&",
        openViewHouseDialog: "&",
    },
    controller: class CanvassItemController {
        // * bindings for typescript compiler *
        public activity?: any;
        public personLink?: string;
        public allowCanvass?: boolean;
        public deleteCanvass: Function;
        public openCanvassDialog: Function;
        public openViewHouseOccupantDialog: Function;
        public openViewHouseDialog: Function;
        // ************************************

        public isLeaderView: boolean = false;
        public showEffort: boolean = false;

        private $scope: any;
        private dialog: DialogUtils;
        private modelsUtils: any;
        private effortDataProvider: EffortDataProvider;

        public __env: any;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            __env: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            ModelsUtils: any,
            EffortDataProvider: EffortDataProvider
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.permissionProvider = PermissionCheck;
            this.effortDataProvider = EffortDataProvider;

            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit(): void {
            this.effortDataProvider.getAllEfforts().then(
                (efforts: Effort[]) => {
                    this.showEffort = efforts.length > 1;
                },
                () => {
                    this.showEffort = false;
                }
            );
        }

        getName(person: object): string {
            let personTmp = this.modelsUtils.houseOccupant(person);
            return personTmp.identifier();
        }

        getHouseAddress(activity: object): string {
            let house = this.modelsUtils.house(activity);
            return house.address();
        }

        openSummaryDialog(canvass: any, ev: any): void {
            this.dialog.show({
                component: "vc-view-summary-dialog",
                targetEvent: ev,
                scope: this.$scope,
                size: "med",
                locals: {
                    signature: canvass.signature,
                    summary: canvass.summary,
                },
            });
        }

        openHiddenInfoDialog(ev: any): void {
            this.dialog.show({
                component: "vc-hidden-info",
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: this.$scope,
                ariaLabel: "List dialog",
                locals: {},
            });
        }

        openAppointmentDialog(activityAppointment: any, ev: any): void {
            let appointment = this.modelsUtils.appointment(activityAppointment);
            this.dialog
                .show({
                    component: "vc-appointment-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedAppointment: appointment,
                    },
                    size: "large",
                    ariaLabel: "Appointment",
                })
                .then((updated: Appointment) => {
                    this.activity.appointment = updated;
                });
        }
    },
};

angular
    .module("activity")
    .component(CanvassItemComponent.selector, CanvassItemComponent);
